import { Box, Button, TextButton } from "@wix/design-system";
import React from "react";
import { useBiNext } from "./../../bi-context-provider/bi-context-provider";
import { LINK_MODAL_ID } from "../constants";
import { CANCEL_BUTTON, SAVE_BUTTON, UNLINK_BUTTON } from "../data-hooks/data-hooks";
const Footer = ({
  onClickCancel,
  onClickSave,
  onClickUnlink,
  showUnlink,
  t
}) => {
  const logBi = useBiNext({ pluginId: "link", modalId: LINK_MODAL_ID });
  const onClickCancelAndLog = () => {
    onClickCancel();
    logBi({ dataHook: CANCEL_BUTTON });
  };
  const onClickSaveAndLog = (evt) => {
    onClickSave(evt);
  };
  const onClickUnlinkAndLog = () => {
    if (onClickUnlink) {
      onClickUnlink();
      logBi({ dataHook: UNLINK_BUTTON });
    }
  };
  return /* @__PURE__ */ React.createElement(Box, { align: "space-between", gap: "SP2", verticalAlign: "middle" }, /* @__PURE__ */ React.createElement(Box, null, showUnlink && /* @__PURE__ */ React.createElement(
    TextButton,
    {
      dataHook: UNLINK_BUTTON,
      onClick: onClickUnlinkAndLog,
      size: "small",
      underline: "always"
    },
    t("LinkSettings_Action_Unlink")
  )), /* @__PURE__ */ React.createElement(Box, { align: "right", gap: "SP2" }, /* @__PURE__ */ React.createElement(
    Button,
    {
      dataHook: CANCEL_BUTTON,
      onClick: onClickCancelAndLog,
      priority: "secondary",
      size: "small"
    },
    t("LinkSettings_Action_Cancel")
  ), /* @__PURE__ */ React.createElement(Button, { dataHook: SAVE_BUTTON, onClick: onClickSaveAndLog, size: "small" }, t("LinkSettings_Action_Save"))));
};
export {
  Footer
};
//# sourceMappingURL=footer.js.map
